import { render, staticRenderFns } from "./ImageInput.vue?vue&type=template&id=510b45c2&scoped=true"
import script from "./ImageInput.vue?vue&type=script&lang=js"
export * from "./ImageInput.vue?vue&type=script&lang=js"
import style0 from "./ImageInput.vue?vue&type=style&index=0&id=510b45c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b45c2",
  null
  
)

export default component.exports